<template>
  <div>
    <div class="white black--text"  v-if="items">
      <div class="headline font-weight-thin pb-8">Order Summary</div>
      <!--            table of items-->
      <app-alert @dismissed="onDismissed"  v-if="error" :text="error.message"></app-alert>
      <v-data-table
          :headers="headers"
          :items="items"
          @click:row="editItem"
          class="elevation-1 hidden-sm-and-down"
          hide-default-footer
      >
        <template v-slot:top>
          <v-toolbar class="mb-3" flat color="white">
            <find-item @ItemFound="itemSelected"></find-item>
          </v-toolbar>
        </template>
<!--        line item edit-->

        <template v-slot:no-data>
          <find-item @ItemFound="itemSelected"></find-item>
        </template>

      </v-data-table>
<!--      <find-item :listingId="orderData.refListing.id" @ItemFound="itemSelected"></find-item>-->
      <find-item class="hidden-md-and-up" @ItemFound="itemSelected"></find-item>
      <v-simple-table
          fixed-header
          class="elevation-1 hidden-md-and-up"
      >
        <template >
          <thead>
          <tr>
            <th class="text-left">
              Name
            </th>
            <th>
              Qty
            </th>
            <th>
              Rate/Price ($)
            </th>
            <th class="text-right">
              Total ($)
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(item, index) in items"
              :key="index"
              @click="editItem(item)"
          >
            <td>{{ item.title }}</td>
            <td>{{ item.qty }}</td>
            <td>{{ item.unitPrice }}</td>
            <td class="text-right">
              {{Number(item.totalPrice).toFixed(2)}}
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-card-actions>
        <v-btn @click="addNewItem" outlined block>Add new item</v-btn>
      </v-card-actions>
      <!--            total-->
      <v-card-actions>
        <!--                    <v-btn @click="updateOrder" icon><v-icon class="primary&#45;&#45;text">autorenew</v-icon></v-btn>-->
        <!--                    <v-spacer></v-spacer>-->
        <v-btn text> Qty: {{totalQuantity }}</v-btn>
        <v-btn text> Invoice Total: ${{totalCost}}</v-btn>
      </v-card-actions>
    </div>
    <v-card>
      <!--        client section-->
      <v-card-title class="headline font-weight-light">Client Info</v-card-title>
      <v-card-text v-if="orderData">
        <v-list>
          <v-list-item v-if="orderData.clientInfo">
            <v-list-item-action><v-icon>person</v-icon></v-list-item-action>
            <v-list-item-content v-if="orderData.clientInfo.name">
              <v-list-item-title>{{orderData.clientInfo.name}}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="orderData.clientInfo.phoneNumber !== ''">
              <v-menu
                  bottom
                  left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                  >
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      <v-btn text router :to="'/numberPortal/'
                      + orderData.clientInfo.connectedPhoneNumber
                      + '/' + orderData.clientInfo.phoneNumber">
                        <v-icon>settings</v-icon>
                        Contact Profile
                      </v-btn>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>
                      <v-btn @click="removeClientInfo" text>
                        <v-icon>close</v-icon>
                        Remove
                      </v-btn>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-action>
          </v-list-item>

          <v-list-item v-if="orderData.clientInfo">
            <v-list-item-action><v-icon>smartphone</v-icon></v-list-item-action>
            <v-list-item-content v-if="orderData.clientInfo.phoneNumber">
              <v-list-item-title>{{orderData.clientInfo.phoneNumber}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="orderData.clientInfo">
            <v-list-item-action><v-icon>email</v-icon></v-list-item-action>
            <v-list-item-content v-if="orderData.clientInfo.email">
              <v-list-item-title>{{orderData.clientInfo.email}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
<!--        search contact app-->
        <contact-picker v-if="!orderData.clientInfo" @userFound="userPicked"></contact-picker>
      </v-card-text>
<!--      Date time section-->
      <v-card-title class="headline font-weight-light" v-if="dateTimeValid">Time and Date</v-card-title>
      <v-card-title class="headline font-weight-light red--text" v-else>Select Time and Date</v-card-title>
      <v-card-text v-if="orderData">
        <date-time-picker :orderTime="orderData.fulfillmentInfo.time"
                          :orderDate="orderData.fulfillmentInfo.date"
                          @dateFound="datePicked"
                          @timeFound="timePicked"
        ></date-time-picker>
      </v-card-text>
<!--          delivery locations-->
      <v-card-title class="headline font-weight-light">Locations</v-card-title>
      <v-layout align-center justify-center v-if="orderData">
        <v-col>
          <v-flex xs12 sm12 md12  v-if="orderData.locations">
            <v-list v-for="location in orderData.locations" :key="location.id">
              <v-list-item>
                <v-list-item-action>
                  <v-icon @click="changeLabel(location.created)" class="red--text">pin_drop</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <h4 class="font-weight-light">{{location.label}}</h4>
                  </v-list-item-title>
                  <v-list-item-title class="font-weight-light">
                    <a style="text-decoration:none" target="_blank" :href="'https://www.google.com/maps/place/' + location.formatted_address">
                      <h3 class="black--text">{{location.formatted_address}}</h3>
                    </a>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <!--                            location options-->
                  <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          icon
                          v-on="on"
                      >
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item @click="moveLocationUp(location.created)" >
                        <v-list-item-action>
                          <v-icon class="black--text">arrow_upward</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>Move Up</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="moveLocationDown(location.created)">
                        <v-list-item-action>
                          <v-icon class="black--text">arrow_downward</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>Move down</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="changeLabel(location.created)">
                        <v-list-item-action>
                          <v-icon class="black--text">label</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>Change Label</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="removeLocation(location.created)">
                        <v-list-item-action>
                          <v-icon class="red--text">clear</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>Remove</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-list>
            </v-list>
          </v-flex>
          <v-flex class="sm12 xs12 md12 ml-12 pl-6 mb-6">
            <locations-autocomplete  @locationFound="saveNewlocation"></locations-autocomplete>
          </v-flex>
        </v-col>
      </v-layout>
<!--invoice message-->
      <v-card-title class="headline font-weight-light">Message</v-card-title>
      <v-card-text v-if="orderData">
        <v-textarea
            rows="3"
            v-model="invoiceMessage"
            placeholder="Auto generated messages from line item notes"
        ></v-textarea>
        <v-textarea
            rows="2"
            v-model="invoiceNote"
            placeholder="Note.."
            append-icon="check"
            @click:append="saveInvoiceNote"
        ></v-textarea>
      </v-card-text>
    </v-card>
      <v-card-title class="headline font-weight-light">Payments</v-card-title>
      <!--      payments section-->
      <v-card-text  v-if="orderData">
        <v-item-group>
            <v-row v-if="orderData.payments.length !== 0">
              <v-col
                  v-for="payment in orderData.payments"
                  :key="payment.created"
                  cols="12"
                  md="4"
              >
                <v-item>
                  <v-card
                      height="200"
                  >
                    <v-app-bar
                        flat
                    >
                      <v-toolbar-title class="text-h6">
                        <v-btn outlined @click="openPaymentStatusDialog(payment)" text>
                        <v-icon class="mr-2">payments</v-icon> {{payment.splitTitle}}
                        </v-btn>
                      </v-toolbar-title>

                      <v-spacer></v-spacer>

                      <v-btn
                          color="red"
                          icon
                          @click="removePayment(payment)"
                      >
                        <v-icon>close</v-icon>
                      </v-btn>
                    </v-app-bar>
                    <v-card-subtitle class="title">$ {{payment.splitAmount}}</v-card-subtitle>
                    <v-card-subtitle class="display-1 green--text" v-if="payment.status">
                      {{payment.status}}
                    </v-card-subtitle>
                    <v-card-text v-if="payment.selectedPaymentMethod" class="title">
                      <div>{{payment.selectedPaymentMethod}}</div>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
            <v-row v-if="orderData.payments.length !== 0">
              <v-col
                  cols="12"
                  md="4"
              >
                <v-item>
                  <v-card
                      height="200"
                  >
                    <v-card-title>
                      <v-btn outlined @click="openPaymentStatusDialog({balance: true})" text>
                      <v-icon class="mr-2">payments</v-icon>Balance
                      </v-btn>
                    </v-card-title>
                    <v-card-subtitle class="title">$ {{balanceRemaining}}</v-card-subtitle>
                    <v-card-subtitle class="display-1 green--text" v-if="orderData.remainingBalanceStatus">
                      {{orderData.remainingBalanceStatus}}
                    </v-card-subtitle>
                    <v-card-text>
                      <v-card-text v-if="orderData.balancePaymentMethod" class="title">
                        <div>{{orderData.balancePaymentMethod}}</div>
                      </v-card-text>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
              <v-col
                  cols="12"
                  md="4"
              >
                <v-item>
                  <v-card
                      height="100"
                      @click="addSplitDialog = true"
                  >
                    <v-card-title><v-icon>add</v-icon><v-icon class="mr-2">payments</v-icon>Split</v-card-title>
                    <v-card-text>Click to split left over balance</v-card-text>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col
                  cols="12"
                  md="4"
              >
                <v-item>
                  <v-card
                      height="220"
                  >
                    <v-card-title>
                      <v-btn @click="openPaymentStatusDialog({balance: true})" text>
                        <v-icon class="mr-2">payments</v-icon>Balance
                      </v-btn>
                    </v-card-title>
                    <v-card-subtitle class="display-1">${{totalCost}}</v-card-subtitle>
                    <v-card-subtitle class="display-1 green--text" v-if="orderData.remainingBalanceStatus">
                      {{orderData.remainingBalanceStatus}}
                    </v-card-subtitle>
                    <v-card-text v-if="orderData.balancePaymentMethod" class="title">
                      <div>{{orderData.balancePaymentMethod}}</div>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
              <v-col
                  cols="12"
                  md="4"
              >
                <v-item>
                  <v-card
                      height="100"
                      @click="addSplitDialog = true"
                  >
                    <v-card-title><v-icon>add</v-icon><v-icon class="mr-2">payments</v-icon>Split</v-card-title>
                    <v-card-text>Click to split left over balance</v-card-text>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
        </v-item-group>
      </v-card-text>
    <v-card-text v-if="orderData">
<!--      <div v-if="orderData.acceptedPaymentMethods.length !== 0">-->
<!--        {{orderData.acceptedPaymentMethods.length}}-->
        <div v-if="orderData.paymentDueNow" class="headline">
          <div v-if="!noDeposit">
            Due Now: ${{orderData.paymentDueNow.splitAmount}}
          </div>
          <div v-if="noDeposit">
            Total: ${{totalCost}}
          </div>
        </div>
      <div>
        <v-switch v-model="noDeposit" color="blue" label="No payment due"></v-switch>
      </div>
<!--      </div>-->
    </v-card-text>

<!--    Accepted Payment methods-->
    <v-card-title class="headline font-weight-light">Accepted Payment Methods</v-card-title>
    <v-select
        v-model="acceptedPaymentMethods"
        :items="payMethodName"
        chips
        item-color="blue"
        label="Payment Methods"
        multiple
        outlined
    ></v-select>

    <!--      order complete section-->
    <div class="mb-4" v-if="invoiceLinkId">
      <v-icon class="mr-2">details</v-icon>
      <a :href="'https://order.flexline.app/' + this.user.publicListingId + '/invoice/' + invoiceLinkId" target="_blank" class="black--text">
        {{'order.flexline.app/' + user.publicListingId + '/invoice/'+ invoiceLinkId}}
      </a>
    </div>
      <v-btn v-if="this.orderData" :disabled="!this.orderData.clientInfo" @click="checkClientEmailRequirements('openInvoice')" class="green mb-3" block dark>
        <v-icon>share</v-icon>
        Share invoice
      </v-btn>
    <v-btn class="blue" block dark @click="toSchedule">Continue to Schedule</v-btn>
<!--    edit line item dialog-->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-text-field v-model="editedItem.title" label="Name"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.qty" type="number" label="Quantity"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.unitCost" type="number" label="Unit Cost"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.unitPrice" type="number" label="Sale Price"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea rows="4" v-model="editedItem.note" label="Note"></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea rows="4" v-model="editedItem.instruction" label="Instruction"></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn small text @click="deleteItem(editedItem)">
            <v-icon  >mdi-delete
            </v-icon>
            Delete
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addSplitDialog"
        persistent
        max-width="300"
    >
      <v-card>
        <v-card-title class="text-h5">
          Split Amount
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="splitTitle"
            label="Split Name"
            placeholder="Deposit"
            prepend-icon="event_note"
          >
          </v-text-field>
          <v-text-field
              v-model="amountSplit"
              label="Amount"
              persistent-hint
              prepend-icon="attach_money"
              type="number"
          ></v-text-field>
          <v-switch
              v-model="splitPercentSwitch"
              label="Percent of balance"
              class="blue--text"
          ></v-switch>
          <v-text-field
              v-if="splitPercentSwitch"
              v-model="percentAmount"
              label="Percent amount"
              persistent-hint
              prepend-icon="percent"
              type="number"
          ></v-text-field>
<!--            <payment-method-picker @paymentMethodPicked="setSplitPaymentMethod"></payment-method-picker>-->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text
              @click="addSplitDialog = false"
          >
            cancel
          </v-btn>
          <v-btn
              color="green darken-1"
              text
              @click="addSplit()"
          >
            Add Split
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="paymentStatusDialog"
        persistent
        max-width="300"
    >
      <v-card>
        <v-card-title v-if="selectedPayment" class="text-h5">
          <v-icon>receipt</v-icon> {{selectedPayment.splitTitle}}
        </v-card-title>
        <v-card-text v-if="selectedPayment" class="headline">
          <v-icon>attach_money</v-icon> {{selectedPayment.splitAmount}}
        </v-card-text>
        <v-card-text v-if="selectedPayment">
          <div v-if="selectedPayment.status !== 'Paid'">
            <v-btn class="blue--text mb-3" block outlined @click="setDueNow"> Due now</v-btn>
            <v-btn class="green--text" block outlined @click="paymentMadeDialog = true">Take Payment</v-btn>
          </div>
          <div v-else>
            <v-icon class="green--text">check</v-icon>Payment Made
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text
              @click="paymentStatusDialog = false"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="paymentMadeDialog"
              persistent
              max-width="300"
    >
      <v-card>
        <v-card-title v-if="selectedPayment" class="text-h5">
          <v-icon>receipt</v-icon> {{selectedPayment.splitTitle}}
        </v-card-title>
        <v-card-text v-if="selectedPayment" class="headline">
          Payment Information
          <div class="mb-3"><v-icon>person</v-icon> {{orderData.clientInfo.name}}</div>
          <div class="mb-3"><v-icon>attach_money</v-icon> {{selectedPayment.splitAmount}}</div>
          <div class="mb-3">
            <v-select
                v-model="transactionPaymentMethod"
                :items="payMethodName"
                label="Payment Method"
            ></v-select>
          </div>
            <v-checkbox
                v-if="orderData.clientInfo.email"
                color="blue"
                v-model="paymentEmailNotification"
                label="Notify over email"
            ></v-checkbox>
            <v-checkbox
                color="blue"
                v-model="paymentTextNotification"
                label="Notify over text"
            ></v-checkbox>
        </v-card-text>
        <v-card-text>
          <v-btn :disabled="!transactionPaymentMethod" v-if="transactionPaymentMethod !== 'Credit'" class="green" dark block @click="paymentComplete">Confirm</v-btn>
          <v-btn :disabled="!transactionPaymentMethod" v-else class="blue--text" block @click="checkClientEmailRequirements('openCardProcessing')" outlined>Charge Card</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text
              @click="paymentMadeDialog = false"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openShareInvoiceDialog"
        max-width="500"
    >
      <v-card v-if="orderData">
        <v-card-title>
          <v-avatar
              class="mt-2"
              size="72px"
              tile
          >
            <img
                v-if="user"
                alt="Avatar"
                :src="user.thumbnailMediaUrl"
            >
          </v-avatar>
        </v-card-title>
        <v-card-title class="text-h5">{{user.name}}</v-card-title>
        <v-card-subtitle class="pt-1">
          Order# {{orderData.created}}
        </v-card-subtitle>

        <v-card-text v-if="orderData">
          <v-list v-if="orderData.fulfillmentInfo">
              <v-list-item-title class="subtitle-1">
                Date: {{orderData.fulfillmentInfo.date}}
                Time: {{orderData.fulfillmentInfo.time}}
              </v-list-item-title>
          </v-list>

          <v-divider></v-divider>
          <v-list v-if="orderData.clientInfo">
            <div class="subtitle-1">Contact</div>
              <v-list-item-content>
                <v-list-item-title v-if="!hideContactName">{{orderData.clientInfo.name}}</v-list-item-title>
                <v-list-item-title>{{orderData.clientInfo.phoneNumber}}</v-list-item-title>
                <v-list-item-title>{{orderData.clientInfo.email}}</v-list-item-title>
                <v-list-item-title><v-switch v-model="hideContactName" color="blue" label="Hide name"></v-switch></v-list-item-title>
              </v-list-item-content>

          </v-list>
          <v-divider></v-divider>
          <v-list v-if="orderData.locations.length!== 0">
            <div v-if="orderData.locations.length < 2" class="subtitle-1">Location</div>
            <div v-if="orderData.locations.length > 1" class="subtitle-1">Locations</div>
            <v-list-item v-for="location in orderData.locations"
                         :key="location.created">
              <v-list-item-content >
                <v-list-item-title>
                  <a style="text-decoration:none" class="blue--text" target="_blank" :href="'https://www.google.com/maps/place/' + location.formatted_address">
                    <div >{{location.formatted_address}}</div>
                  </a>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-text  v-if="items">
          <div class="subtitle-1 pb-4">Order Summary</div>
          <v-simple-table
              fixed-header
          >
            <template >
              <thead>
              <tr>
                <th class="text-left">
                  Item
                </th>
                <th>
                  Qty
                </th>
                <th>
                  Total
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="(item, index) in items"
                  :key="index"
              >
                <td>{{ item.title }}</td>
                <td>{{ item.qty }}</td>
                <td>{{ item.totalPrice }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-btn text> Total Cost: ${{totalCost}}</v-btn>
        </v-card-text>

        <v-card-text>
          <v-divider></v-divider>
          <div class="subtitle-1 mt-4">Payments</div>
          <v-simple-table v-if="orderData">
            <template v-slot:default>
              <tbody>
              <tr
                  v-for="item in orderData.payments"
                  :key="item.created"
              >
                <td>{{ item.splitTitle }}</td>
                <td>$ {{ item.splitAmount }}</td>
              </tr>
              <tr>
                <td>Remaining Balance</td>
                <td>$ {{balanceRemaining}}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-text class="mb-4">
          <div v-if="orderData.paymentDueNow" class="headline mb-4">
            <div v-if="!noDeposit">
              Due Now: ${{orderData.paymentDueNow.splitAmount}}
            </div>
            <div v-if="noDeposit">
              Total: ${{totalCost}}
            </div>
          </div>
          <v-row justify="center">
            <v-expansion-panels multiple inset>
              <v-expansion-panel
                  v-for="payment in orderData.acceptedPaymentMethods"
                  :key="payment.id"
              >
                <v-expansion-panel-header>
                <v-img contain :src="payment.thumbNailImg" max-height="75" max-width="150"></v-img>{{payment.paymentMethod}}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-img contain :src="payment.imageUrl" max-height="150" max-width="150"></v-img>
                  {{payment.description}}
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
          <v-btn :disabled="!this.orderData.clientInfo" block class="mt-5 mb-2"  outlined @click="textInvoiceLink"><v-icon>smartphone</v-icon>send over text</v-btn>
          <v-btn :disabled="!this.orderData.clientInfo" block class="mt-5" outlined @click="initEmailInvoice"><v-icon>email</v-icon>send over email</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text
              @click="openShareInvoiceDialog = false"
          >
            cancel
          </v-btn>
          <v-btn
              color="green darken-1"
              text
              @click="publishInvoice"
          >
            Publish
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="notificationDialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ notificationDialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-textarea
              clearable
              label="Message"
              placeholder="message body ..."
              v-model="notificationMsg"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeNotificationMsg">cancel</v-btn>
          <v-btn class="blue" dark @click="sendText"><v-icon>send</v-icon>Send Text</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openEmailInvoiceDialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Email Invoice</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
              prepend-icon="person"
              v-model="emailName"
              label="Name"
              required
          ></v-text-field>
          <v-text-field
              prepend-icon="email"
              name="login"
              v-model="emailTo"
              :rules="emailRules"
              label="Email"
              type="text"
              required>
          </v-text-field>
          <v-text-field
              prepend-icon="business"
              name="Company Name"
              v-model="contactCompanyName"
              label="Company Name"
              type="text"
              >
          </v-text-field>
          <v-textarea
              rows="6"
              v-model="emailMsg"
              prepend-icon="message"
              label="Message"
              outlined
          >
          </v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="openEmailInvoiceDialog =false">cancel</v-btn>
          <v-btn :disabled="!validEmail" class="blue" dark @click="sendInvoiceOverEmail"><v-icon>email</v-icon> Send email</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="paymentMadeEmailDialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Payment Made Email</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
              prepend-icon="person"
              v-model="emailName"
              label="Name"
              required
          ></v-text-field>
          <v-text-field
              prepend-icon="email"
              name="login"
              v-model="emailTo"
              :rules="emailRules"
              label="Email"
              type="text"
              required>
          </v-text-field>
          <v-text-field
              prepend-icon="business"
              name="Company Name"
              v-model="contactCompanyName"
              label="Company Name"
              type="text"
          >
          </v-text-field>
          <v-textarea
              v-model="emailMsg"
              prepend-icon="message"
              label="Message"
              outlined
          >
          </v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="paymentMadeEmailDialog =false">cancel</v-btn>
          <v-btn :disabled="!validEmail" class="blue" dark @click="sendPaymentMadeOverEmail"><v-icon>email</v-icon> Send email</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="changeLocationLabel"
              ref="dialog"
              persistent
    >
      <v-card>
        <v-card-text>
          <v-flex xs12 sm6 offset-sm3>
            <v-card-title>
              <div class="headline font-weight-light">Change Location Label</div>
            </v-card-title>
            <v-text-field outline v-model="selectedLocationLabel" label="Label" placeholder="i.e. unit#305"></v-text-field>
            <v-checkbox color="blue" v-model="newLocationPickupCheckbox" label="Pick-up"></v-checkbox>
            <v-checkbox color="blue" v-model="newLocationDropOffCheckbox" label="drop-off"></v-checkbox>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="dark" @click="changeLocationLabel = false" text>cancel</v-btn>
          <v-btn v-if="!loading"  class="blue--text" dark outlined @click="updateLocationLabel()">Add Label</v-btn>
          <app-loading v-else></app-loading>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="missingDataWarningDialog"
              ref="dialog"
              persistent
              width="290px"
    >

      <v-card>
        <v-card-title>
          <div class="white black--text
                    text-xs-center
                    font-weight-thin display-1">Email Missing</div>
        </v-card-title>
        <v-card-text>
          Add a client email to share payment details.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="missingDataWarningDialog = false">ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import {addDoc, collection, doc, getDocs, onSnapshot, setDoc, updateDoc} from "firebase/firestore";
import {v1 as uuidv1} from "uuid";
import { arrayMoveImmutable } from 'array-move'
export default {
  components: {},

  props: ["id"],
  data () {
    return {
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      orderData: undefined,
      items: undefined,
      totalCost: 0,
      totalQuantity: 0,
      totalProfit: 0,
      scheduleData: undefined,
      dialog: false,
      headers: [
        { text: 'Name', align: 'start', sortable: true, value: 'title'},
        { text: 'Qty', value: 'qty', sortable: false },
        { text: 'Unit Cost ($)', value: 'unitCost', sortable: false },
        { text: 'Sale Price ($)', value: 'unitPrice', sortable: false },
        { text: 'Line total ($)', value: 'totalPrice', sortable: false },
      ],
      editedIndex: -1,
      editedItem: {
        qty: 0,
        price: 0,
        cost: 0,
        title: '',
        note: '',
        instruction: ''
      },
      defaultItem: {
        qty: 0,
        price: 0,
        cost: 0,
        title: '',
        note: '',
        instruction: ''
      },
      addSplitDialog: false,
      amountSplit: 0,
      percentAmount: 0,
      splitTitle: 'Deposit',
      paymentMethods: null,
      splitPercentSwitch: false,
      balanceRemaining: 0,
      splitPaymentMethod: null,
      selectedPayment: null,
      openShareInvoiceDialog: false,
      paymentStatusDialog: false,
      hideContactName: false,
      paymentMethodsPanel: [0],
      invoiceLinkId: null,
      notificationMsg: null,
      notificationDialog: false,
      notificationDialogTitle: '',
      changeLocationLabel: false,
      selectedLocationLabel: '',
      selectedLocationId: '',
      newLocationPickupCheckbox: false,
      newLocationDropOffCheckbox: false,
      acceptedPaymentMethods: [],
      payMethodName: [],
      emailTo: null,
      emailName: '',
      openEmailInvoiceDialog: false,
      contactCompanyName: '',
      emailMsg: "",
      noDeposit: false,
      paymentMadeDialog: false,
      transactionPaymentMethod: null,
      paymentEmailNotification: false,
      paymentTextNotification: false,
      paymentMadeEmailDialog: false,
      emailPaymentsObj: null,
      invoiceMessage: '',
      missingDataWarningDialog: false,
      invoiceNote: ''
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    // paymentMethodsPanel (value) {
    //   //console.log(value)
    // },
    percentAmount (val) {
      this.amountSplit = Math.round(((val/100)* this.balanceRemaining)*100) / 100
    },
  },
  created () {
    //this.$store.dispatch('setLoading', true)
    let db = this.$store.state.db
    let uid = this.user.uid
    let orderRef = doc(db, 'users', uid + '/orders/' + this.id)
    onSnapshot(orderRef, res => {
      if(res.exists) {
        this.orderData = res.data()
        // console.log(this.orderData)
        let items = []
        let invoiceMsg = ''
        res.data().lineItems.forEach(item => {
          item.totalPrice = Number(item.unitPrice * item.qty).toFixed(2)
          items.push(item)
          if (item.note !== '') {
            invoiceMsg += ' ' + item.note + '.'
          }

        })
        let payments = []
        res.data().payments.forEach(payment => {
          payments.push(payment)
        })
        if (this.orderData.clientInfo) {
          let client = this.orderData.clientInfo
          if (client.companyName) {
            this.contactCompanyName = client.companyName
          }
        }
        if (this.orderData.invoiceNote) {
          this.invoiceNote = this.orderData.invoiceNote
        }
        this.invoiceMessage = invoiceMsg
        this.items = items
        this.calcTotals(items)
        this.calcBalance(payments)
        //console.log(this.items)
      }
    })
    let paymentsRef = getDocs(collection(db, 'users', uid+ '/paymentMethods'))
    return paymentsRef
        .then (methods => {
          let methodsList = []
          let methodNamesOnly = []
          methods.forEach (method => {
            if(method.data().enabled) {
              methodsList.push(method.data())
              methodNamesOnly.push(method.data().paymentMethod)
            }
          })
          this.paymentMethods = methodsList
          let paymentMethodItems = []
          methodsList.forEach(method => {
            //console.log(method.paymentMethod)
            paymentMethodItems.push(method.paymentMethod)
          })
          this.payMethodName = paymentMethodItems
          if (!this.orderData.acceptedPaymentMethods) {
            this.orderData.acceptedPaymentMethods = methodsList
            this.acceptedPaymentMethods = paymentMethodItems
          } else {
            let payMethods = []
            this.orderData.acceptedPaymentMethods.forEach(method =>{
              payMethods.push(method.paymentMethod)
            })
            this.acceptedPaymentMethods = payMethods
            this.transactionPaymentMethod = payMethods[0]
          }
        })
  },
  computed: {
    dateTimeValid () {
      if (this.orderData) {
        return !!(this.orderData.fulfillmentInfo.time
            && this.orderData.fulfillmentInfo.date);
      }
      return false
    },
    validEmail () {
      return String(this.emailTo)
          .toLowerCase()
          .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    profitAfterDelivery () {
      let profit = 0
      if (this.scheduleData.payouts){
        profit = this.totalProfit - this.scheduleData.payouts.contractorPrice
      }
      return profit.toFixed(2)
    },
    deliveryCost () {
      if (this.scheduleData.payouts){
        return this.scheduleData.payouts.contractorPrice
      } else return 0
    },
    formTitle () {
      return this.editedItem.title
    },
    moment () {
      return (date) => {
        let day = moment(date).format('ddd, MMM Do, hh:mm A')
        return day
      }
    },
    transactionTime () {
      return (date) => {
        let timeStamp = moment(date).format('ddd, MMM Do YYYY, hh:mm A')
        return timeStamp
      }
    },
    momentDate () {
      return (date) => {
        let day = moment(date).format('dddd, LL')
        return day
      }
    },
    user () {
      return this.$store.getters.user
    },
    invoiceObj () {
      let invoiceObj = {
        logo: this.user.thumbnailMediaUrl,
        publicListingId: this.user.publicListingId,
        listingName: this.user.name,
        payInvoiceLink: 'https://order.flexline.app/' + this.user.publicListingId + '/invoice/' + this.id,
        invoiceTitle: this.orderData.locations[0].name,
        invoiceNumber: this.id.slice(0, 8),
        dateCreated: this.momentDate(this.orderData.created),
        contactName: null,
        contactEmail: this.emailTo,
        contactPhoneNumber: null,
        companyName: this.contactCompanyName,
        contactAddress: null,
        dateOfService: null,
        locations: null,
        lineItems: null,
        totalCost: this.totalCost,
        dueNow: this.orderData.paymentDueNow.splitAmount,
        dueNowObj: this.orderData.paymentDueNow,
        dueDate: this.momentDate(this.orderData.paymentDueNow.created),
        userEmail: this.user.email,
        userPhoneNumber: null,
        paymentNotRequired: this.noDeposit
      }
      if (this.orderData.fulfillmentInfo.time) {
        invoiceObj.time = this.orderData.fulfillmentInfo.time
      } else {
        invoiceObj.time = ''
      }
      if (this.orderData.fulfillmentInfo.date) {
        invoiceObj.dateOfService = this.orderData.fulfillmentInfo.date
      } else {
        invoiceObj.dateOfService = ''
      }
      if (this.orderData.clientInfo) {
        if (!this.hideContactName) {
          if (this.emailName !== "") {
            invoiceObj.contactName = this.emailName
          } else {
            invoiceObj.contactName = this.orderData.clientInfo.name
          }
        }
        invoiceObj.contactPhoneNumber = this.orderData.clientInfo.phoneNumber
        if(this.orderData.clientInfo.meetupLocation) {
          invoiceObj.contactAddress = this.orderData.clientInfo.meetupLocation.formatted_address
        } else {
          invoiceObj.contactAddress = ''
        }
        invoiceObj.userPhoneNumber = this.orderData.clientInfo.connectedPhoneNumber
      }
      if (!this.emailTo) {
        invoiceObj.contactEmail = this.orderData.clientInfo.email
      }
      if (this.orderData.locations.length !== 0) {
        let locations = this.orderData.locations
        let labeledLocals = []
        locations.forEach(location => {
          let locName = {name: location.name}
          if (location.label) {
            locName = {name: location.label + ' ' + location.name}
          }
          labeledLocals.push(locName)
        })
        invoiceObj.locations = labeledLocals
      }
      if (this.orderData.lineItems.length !== 0) {
        let emailItems = []
        this.orderData.lineItems.forEach(item => {
          emailItems.push({
            title: item.title,
            totalPrice:  Number(item.totalPrice).toFixed(2),
            unitPrice: item.unitPrice,
            qty: item.qty,
            note: item.note})
        })
        invoiceObj.lineItems = emailItems
      }
      invoiceObj.payments = this.orderData.payments
      invoiceObj.balanceRemaining = this.balanceRemaining
      if (this.orderData.remainingBalanceStatus) {
        invoiceObj.remainingBalanceStatus = this.orderData.remainingBalanceStatus
      }
      if (this.invoiceMessage !== '') {
        invoiceObj.message = this.invoiceMessage
      }
      invoiceObj.paymentMethods = this.paymentMethods
      if (this.orderData.acceptedPaymentMethods) {
        invoiceObj.paymentMethods = this.orderData.acceptedPaymentMethods
      }
      return invoiceObj
    }
  },
  methods: {
    saveInvoiceNote () {
      this.orderData.invoiceNote = this.invoiceNote
      this.updateOrder()
    },
    addNewItem () {
      let newItem = {title: 'Item'}
      newItem.unitPrice = 0
      newItem.unitCost = 0
      newItem.note = ''
      newItem.instruction = ''
      newItem.id = uuidv1()
      return this.itemSelected(newItem)
    },
    checkClientEmailRequirements (nextAction) {
      if (this.noDeposit) {
        if (nextAction === 'openInvoice') {
          this.loadShareDialog()
        }
        if (nextAction === 'openCardProcessing') {
          this.openCreditProcessing()
        }
      }
      if (!this.noDeposit){
        if (this.orderData.clientInfo.email) {
          // console.log(this.orderData.clientInfo)
          if (nextAction === 'openInvoice') {
            this.loadShareDialog()
          }
          if (nextAction === 'openCardProcessing') {
            this.openCreditProcessing()
          }
        }
        else {
          this.missingDataWarningDialog = true
        }
        // let creditAllowed = false
        // this.acceptedPaymentMethods.forEach(method => {
        //   if (method.paymentMethod) {
        //     creditAllowed = true
        //   }
        // })
        // if (creditAllowed) {
        //   if (this.orderData.clientInfo.email) {
        //     // console.log(this.orderData.clientInfo)
        //     if (nextAction === 'openInvoice') {
        //       this.loadShareDialog()
        //     }
        //     if (nextAction === 'openCardProcessing') {
        //       this.openCreditProcessing()
        //     }
        //   }
        //   else {
        //     this.missingDataWarningDialog = true
        //   }
        // }
        // if (!creditAllowed){
        //   if (nextAction === 'openInvoice') {
        //     this.loadShareDialog()
        //   }
        //   if (nextAction === 'openCardProcessing') {
        //     this.openCreditProcessing()
        //   }
        // }
      }
    },
    openCreditProcessing () {
      let paymentObj = {
        orderData: this.orderData,
        invoiceObj: this.invoiceObj,
        paymentInfo: this.selectedPayment,
        transactionTime: this.transactionTime(Date.now()),
        notificationMethods: {
          email: this.paymentEmailNotification,
          text: this.paymentTextNotification
        },
        userData: this.user
      }
      // console.log(paymentObj)
      this.$store.dispatch('initCardPayment', paymentObj)
    },
    notifyClient (msg) {
      //console.log(msg)
      let id = uuidv1()
      let user = this.orderData.clientInfo
      let msgObj = {
        text: msg,
        created: Date.now(),
        id: id,
        direction: 'outgoing'
      }
      //console.log(this.fulfillmentData.orderData.clientInfo)
      let db = this.$store.state.db
      let time = Date.now()
      let userSMSRef = doc(db, 'users', this.user.uid + '/provisionedNumbers/'+ user.connectedPhoneNumber + '/sms/'+ user.phoneNumber)
      let userMsgsRef = collection(db, 'users', this.user.uid + '/provisionedNumbers/' + user.connectedPhoneNumber + '/sms/' + user.phoneNumber + '/messages')
      updateDoc(userSMSRef,{
        lastActive: time,
        lastMessage: msgObj.text
      })
          .then(()=> {
            let outgoingMsg = {...msgObj}
            outgoingMsg.created = time
            if (this.mediaUrl) {
              outgoingMsg.mediaUrl = this.mediaUrl
              // if (this.textMessage !== '') {
              //   outgoingMsg.text = ' '
              // }
            }
            return addDoc(userMsgsRef, outgoingMsg)
          })
          // .then(() => {
          //   updateDoc(segmentContactRef, {lastActive: time, lastMessage: msgObj.text})
          // })
          .catch(err => {
            this.$store.dispatch('setError', err)
            console.log(err)
          })
    },
    sendText () {
      this.notificationDialog = false
      if (this.smsClient) {
        this.notifyClient (this.notificationMsg)
        let progress = {
          type: 'invoice',
          method: 'sms',
          invoice: this.invoiceObj,
          msg: this.notificationMsg,
          title: 'Invoice sent over text',
          created: Date.now()
        }
        this.updateBookingProgress(progress)
      }
      this.closeNotificationMsg ()
      this.publishInvoice()
      this.openEmailInvoiceDialog =false
      this.openShareInvoiceDialog = false
    },
    initEmailInvoice () {
      let emailMsg = null
      this.openEmailInvoiceDialog = true
      this.emailName = this.orderData.clientInfo.name
      let order = this.orderData
      if (order.clientInfo.email) {
        this.emailTo = order.clientInfo.email
      } else {this.emailTo = ''}
      if (order.fulfillmentInfo.time) {
        let startTime = 'Start time: ' + order.fulfillmentInfo.time
        if (!this.noDeposit) {
          startTime += '. Total due today $' + this.orderData.paymentDueNow.splitAmount +'. Final balance of $'
              + this.balanceRemaining + ' is due after completion. '
        }
        emailMsg = startTime
      }
      this.emailMsg = emailMsg + this.invoiceNote
    },
    sendInvoiceOverEmail () {
      //console.log(this.emailTo)
      if (this.emailTo !== '') {
        let db = this.$store.state.db
        let uid = this.user.uid
        let emailId = uuidv1()
        //set email body with type and email data
        let emailObj = {
          id: emailId,
          invoiceObj: this.invoiceObj,
          type: 'detailedInvoiceDueNow',
          created: Date.now(),
          from: {
            name: this.user.name
          },
          replyTo: {
            name: this.user.name,
            address: this.user.email
          },
          to: [{email: this.emailTo, name: this.emailName}]
        }
        emailObj.invoiceObj.emailMsg = this.emailMsg
        if (this.noDeposit) {
          emailObj.type = 'detailedInvoiceNoDeposit'
        }
        //console.log(this.user)
        let outgoingEmailRef = doc(db, 'users', uid + '/outgoingEmail/' + emailObj.id)
        return setDoc(outgoingEmailRef, emailObj)
            .then(() => {
              //update booking progress
              let progress = {
                type: 'detailedInvoiceDueNow',
                method: 'email',
                emailObj: emailObj,
                invoice: this.invoiceObj,
                title: 'Invoice Due Sent',
                created: Date.now()
              }
              if (!this.noDeposit) {
                progress.title = 'Invoice Total Sent'
              }
              this.updateBookingProgress(progress)
              //Publish invoice for  webview
              this.publishInvoice()
              this.openEmailInvoiceDialog =false
              this.openShareInvoiceDialog = false
            })
      }

    },
    updateBookingProgress (obj) {
      if (this.orderData.progress) {
        this.orderData.progress.push(obj)
        this.updateOrder()
      } else {
        this.orderData.progress = [obj]
        this.updateOrder()
      }
    },
    closeNotificationMsg () {
      this.notificationDialog = false
      this.notificationDialogTitle = ''
      this.notificationMsg = ''
    },
    textInvoiceLink () {
      this.smsClient = true
      this.notificationDialogTitle = "Text " + this.orderData.clientInfo.name
      this.notificationMsg = "Here's the final invoice: " + 'https://order.flexline.app/' + this.user.publicListingId + '/invoice/' + this.id
      this.notificationDialog = true
    },
    syncAcceptedPaymentMethods () {
      let selectedPaymentMethods = []
      this.acceptedPaymentMethods.forEach(method => {
        let fullObj = this.paymentMethods.find(methodObj => {
          return methodObj.paymentMethod === method
        })
        selectedPaymentMethods.push(fullObj)
      })
      this.orderData.acceptedPaymentMethods = selectedPaymentMethods
      this.updateOrder()
    },
    loadShareDialog () {
      this.syncAcceptedPaymentMethods()
      this.openShareInvoiceDialog = true
    },
    publishInvoice () {
      let obj = this.invoiceObj
      // console.log(obj)
      let listingId = this.user.publicListingId
      let db = this.$store.state.db
      let salesRef = doc(db, 'publicListings', listingId, 'invoices', this.id)
      return setDoc(salesRef, obj)
          .then(() => {
            window.open('https://order.flexline.app/' + this.user.publicListingId + '/invoice/' + this.id)
            this.invoiceLinkId = this.id
            this.openShareInvoiceDialog = false
          })
          .catch(err => [
            this.$store.dispatch('setError', err)
          ])
    },
    openPaymentStatusDialog(payment) {
      if(payment.balance) {
        // console.log('Set Balance as ActivePayment')
        let obj = {
          created: Date.now(),
          splitTitle: 'Remaining Balance',
          splitAmount: this.balanceRemaining
        }
        this.selectedPayment = obj
      }
      if(!payment.balance){
        // console.log('Set: ' + payment.splitTitle + ' as active payment')
        this.selectedPayment = payment
      }
      // console.log(this.selectedPayment)
      this.paymentStatusDialog = true
    },
    setDueNow () {
      this.orderData.paymentDueNow = this.selectedPayment
      this.paymentStatusDialog = false
      // console.log(this.invoiceObj)
      this.updateOrder()
    },
    paymentComplete () {
      let db = this.$store.state.db
      // fetches transactions associated by this number
      let transactionsRef = collection(db, 'users', this.user.uid + '/transactions')
      if (this.selectedPayment.splitTitle === 'Remaining Balance') {
            this.orderData.remainingBalanceStatus = 'Paid'
          }
      else {
        // console.log(this.selectedPayment.splitTitle)
        let paymentIndex = this.orderData.payments.indexOf(this.selectedPayment)
        // console.log(paymentIndex)
        this.orderData.payments[paymentIndex].status = 'Paid'
      }
      let transactionObj = {
        paidBy: this.orderData.clientInfo,
        receivedBy: this.user,
        direction: 'incoming',
        amount: this.selectedPayment.splitAmount,
        transactionTitle: this.selectedPayment.splitTitle,
        created: Date.now(),
        paymentMethod: this.transactionPaymentMethod,
        orderId: this.id
      }
      if (!this.orderData.clientInfo) {
        transactionObj.paidBy = 'Unknown'
      }
      if (this.paymentTextNotification === true) {
        this.smsClient = true
        this.notificationMsg = 'Received a payment amount of $' + transactionObj.amount + '. Thank you!'
        this.notificationDialogTitle = 'Payment Made'
        this.notificationDialog = true
        let progress = {
          type: 'paymentMadeNotifiedText',
          method: 'text',
          invoice: this.invoiceObj,
          title: 'Payment made',
          created: Date.now()
        }
        this.updateBookingProgress(progress)
      }
      if (this.paymentEmailNotification === true) {
        this.emailPaymentsObj = {
          payments: this.orderData.payments,
          paymentMadeAmount: transactionObj.amount,
          type: transactionObj.type,
          timeStamp: this.moment(transactionObj.created),
          paymentMethod: transactionObj.paymentMethod
        }
        this.initPaymentMadeEmail()
      }
      //console.log(transactionObj)
      return addDoc(transactionsRef, transactionObj)
          .then (() => {
            this.paymentStatusDialog = false
            this.paymentMadeDialog = false
            this.publishInvoice()
            this.updateOrder()
          })
    },
    initPaymentMadeEmail () {
      let emailMsg = null
      this.paymentMadeEmailDialog = true
      this.emailName = this.orderData.clientInfo.name
      let order = this.orderData
      if (order.clientInfo.email) {
        this.emailTo = order.clientInfo.email
      } else {this.emailTo = ''}
      if (order.fulfillmentInfo.time) {
        emailMsg = 'Payment received. Thank you!'
      }
      this.emailMsg = emailMsg
    },
    sendPaymentMadeOverEmail () {
      //console.log(this.emailTo)
      if (this.emailTo !== '') {
        let db = this.$store.state.db
        let uid = this.user.uid
        let emailId = uuidv1()
        //set email body with type and email data
        let emailObj = {
          id: emailId,
          invoiceObj: this.invoiceObj,
          type: 'detailedPaymentMade',
          created: Date.now(),
          from: {
            name: this.user.name
          },
          replyTo: {
            name: this.user.name,
            address: this.user.email
          },
          to: [{email: this.emailTo, name: this.emailName}]
        }
        emailObj.invoiceObj.emailMsg = this.emailMsg
        emailObj.paymentDetails = this.emailPaymentsObj
        //console.log(this.user)
        let outgoingEmailRef = doc(db, 'users', uid + '/outgoingEmail/' + emailObj.id)
        return setDoc(outgoingEmailRef, emailObj)
            .then(() => {
              //update booking progress
              let progress = {
                type: 'paymentMadeNotifiedEmail',
                method: 'email',
                emailObj: emailObj,
                invoice: this.invoiceObj,
                title: 'Payment made',
                created: Date.now()
              }
              this.updateBookingProgress(progress)
              this.paymentMadeEmailDialog = false
            })
      }

    },
    setSplitPaymentMethod (value) {
      this.splitPaymentMethod = value.paymentMethod
    },
    addPaymentMethod (value) {
      this.orderData.balancePaymentMethod = value.paymentMethod
      this.updateOrder()
    },
    removeBalancePayMethod () {
      this.orderData.balancePaymentMethod  = null
      this.updateOrder()
    },
    removePayment (payment) {
      // console.log(payment)
      this.orderData.paymentDueNow = {
        created: Date.now(),
        splitTitle: 'Remaining Balance',
        splitAmount: this.balanceRemaining
      }
      // console.log(this.orderData.paymentDueNow)
      let index = this.orderData.payments.indexOf(payment)
      this.orderData.payments.splice(index, 1)
      this.updateOrder()
    },
    addSplit () {
      this.addSplitDialog = false
      let paymentObj = {
        splitAmount: this.amountSplit,
        splitTitle: this.splitTitle,
        created: Date.now(),
        //selectedPaymentMethod: this.splitPaymentMethod
      }
      this.orderData.paymentDueNow = paymentObj
      this.splitPaymentMethod = null
      this.amountSplit = 0
      this.percentAmount = 0
      this.orderData.payments.push(paymentObj)
      // console.log(paymentObj)
      this.updateOrder()
    },
    moveLocationDown (created) {
      let movedLocation = this.orderData.locations.find((location) => {
        return location.created === created
      })
      let index = this.orderData.locations.indexOf(movedLocation)
      this.orderData.locations = arrayMoveImmutable(this.orderData.locations, index, index+1)
      this.updateOrder()
    },
    moveLocationUp (created) {
      let movedLocation = this.orderData.locations.find((location) => {
        return location.created === created
      })
      let index = this.orderData.locations.indexOf(movedLocation)
      this.orderData.locations = arrayMoveImmutable(this.orderData.locations, index, index - 1)
      //this.reCalculateLocationCost()
      this.updateOrder()
    },
    changeLabel (locationCreated) {
      console.log(locationCreated)
      let movedLocation = this.orderData.locations.find((location) => {
        return location.created === locationCreated
      })
      let index = this.orderData.locations.indexOf(movedLocation)
      this.changeLocationLabel = true
      this.selectedLocationLabel = this.orderData.locations[index].label
      this.selectedLocation = locationCreated
    },
    updateLocationLabel () {
      let movedLocation = this.orderData.locations.find((location) => {
        return location.created === this.selectedLocation
      })
      let index = this.orderData.locations.indexOf(movedLocation)
      this.orderData.locations[index].label = this.selectedLocationLabel

      if (this.orderData.locations[index].label) {
        if (this.newLocationPickupCheckbox) {
          this.orderData.locations[index].label += ' Pick-up'
        }
        if (this.newLocationDropOffCheckbox) {
          this.orderData.locations[index].label += ' Drop-off'
        }
      } else {
        if (this.newLocationPickupCheckbox) {
          this.orderData.locations[index].label = ' Pick-up'
        }
        if (this.newLocationDropOffCheckbox) {
          this.orderData.locations[index].label = ' Drop-off'
        }
      }

      this.updateOrder()
      this.newLocationDropOffCheckbox = false
      this.changeLocationLabel = false
    },
    removeLocation (locationCreated) {
      let changedLocation = this.orderData.locations.find((location) => {
        return location.created === locationCreated
      })
      let locationIndex = this.orderData.locations.indexOf(changedLocation)
      //
      // let index = this.orderData.locations.indexOf(location)
      this.orderData.locations.splice(locationIndex, 1)
      this.updateOrder()
    },
    saveNewlocation (location) {
      let local = location
      if (!this.orderData.locations) {
        this.orderData.locations = []
        this.orderData.locations.push(local)
      } else {
        this.orderData.locations.push(local)
      }
      // console.log(this.orderData)
      this.updateOrder()
    },
    datePicked (date) {
      this.orderData.fulfillmentInfo.date = date
      this.updateOrder()
    },
    timePicked (time) {
      this.orderData.fulfillmentInfo.time = time
      this.updateOrder()
    },
    calcTotals (value) {
      if(value.length !== 0) {
        let totalQty = 0
        let totalCost = 0
        let totalProfit = 0
        let totalBuyingCost = 0
        for(let i in value){
          // console.log(value)
          totalQty += Number(value[i].qty)
          totalCost += Number(value[i].unitPrice) * Number(value[i].qty)
          totalBuyingCost += Number(value[i].unitCost) * Number(value[i].qty)
        }
        // console.log(totalCost)
        totalProfit = totalCost - totalBuyingCost
        this.totalCost = Number(totalCost).toFixed(2)
        this.totalQuantity = Number(totalQty).toFixed(2)
        this.totalProfit = totalProfit
      }
    },
    calcBalance (payments) {
      let splitTotal = 0
      let discount = 0
      payments.forEach(payment => {
        if (payment.splitAmount > 0) {
          splitTotal += Number(payment.splitAmount)
        }
        if (payment.splitAmount < 0) {
          discount += Number(payment.splitAmount)
        }
      })
      this.balanceRemaining = this.totalCost - splitTotal + discount
      if (!this.orderData.paymentDueNow) {
        this.orderData.paymentDueNow = {
          created: Date.now(),
          splitTitle: 'Remaining Balance',
          splitAmount: this.balanceRemaining
        }
      }
    },
    editItem (item) {
      this.editedIndex = this.items.indexOf(item)
      // console.log(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      let deleteItem = this.items.find(i => {
        return i.id === item.id
      })
      const index = this.items.indexOf(deleteItem)
      // console.log(index)
      this.items.splice(index, 1)
      this.dialog = false
      this.updateOrder()
    },
    removeClientInfo () {
      this.orderData.clientInfo = null
      // console.log(this.orderData)
      this.updateOrder()
    },
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    save () {
      // console.log(this.editedIndex)
      if (this.editedIndex > -1) {
        // console.log(this.editedItem)
        this.editedItem.totalPrice =  Number(this.editedItem.qty * this.editedItem.unitPrice).toFixed(2)
        Object.assign(this.items[this.editedIndex], this.editedItem)
        //console.log(this.items)
      }
      this.calcTotals (this.items)
      this.orderData.items = this.items
      this.updateOrder()
      this.close()
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    cancel() {
      this.pickedItem = undefined
      this.searchItem = ''
    },
    toSchedule () {
      this.orderData.status = "success"
      this.updateOrder()
      let db = this.$store.state.db
      let fulfillmentRef = doc(db, 'users', this.user.uid + '/fulfillment/' + this.id)
      let scheduleRef = doc(db, 'users', this.user.uid + '/dispatch/' + this.id)
      //console.log(this.orderData)
      let fulfillmentOrderData = {...this.orderData}
      delete fulfillmentOrderData.items
      updateDoc( scheduleRef,{orderData: this.orderData})
      updateDoc(fulfillmentRef, {orderData: fulfillmentOrderData})
          .catch(err => {
            this.$store.dispatch('setError', err)
          })
    },
    updateStock () {
      let itemsRef = this.$store.state.admin2.firestore().collection('items')
      let items = this.items
      for(let key in items) {
        //console.log(items[key].qty)
        let itemRef = itemsRef.doc(items[key].id)
        itemRef.get()
            .then(res => {
              let data = res.data()
              let stock = Number(data.inventory)
              data.inventory = stock - items[key].qty

              //console.log(data)
              return itemRef.update(data)
            })
      }
    },
    itemSelected (value) {
      let item = value
      item.qty = 1
      this.items.push(item)
      this.calcTotals(this.items)
      this.updateOrder()
    },
    updateOrder() {
      let db = this.$store.state.db
      let orderRef = doc(db, 'users', this.user.uid + '/orders/' + this.id)
      this.orderData.lineItems = this.items
      // console.log(this.orderData)
      updateDoc(orderRef, this.orderData)
          .catch(err => {
            this.$store.dispatch('setError', err)
          })
    },
    userPicked (user) {
      console.log(user)
      this.orderData.clientInfo = user
      this.updateOrder()
      if(user.phoneNumber) {
        if(user.connectedPhoneNumber) {
          let db = this.$store.state.db
          let smsRef = doc(db, 'users', this.user.uid, 'provisionedNumbers', user.connectedPhoneNumber, 'sms', user.phoneNumber)
          updateDoc(smsRef, {activeBooking: this.id})
              .catch(err => {
                this.$store.dispatch('setError', err)
              })
        }
      }
      if(user.meetupLocation){
        //console.log(user)
        // this.$store.state.admin1.firestore().collection('scheduling').doc(this.id).update({meetupLocation: user.meetupLocation})
      }
    }
  }
}
</script>
